export const trackGTMEvent = (update: object) => {
  const gtm = window.dataLayer;
  if (gtm) {
    gtm.push(update);
  }
};
